<section class="login-container">
  <div class="row g-0 h-100">
    <!-- Lado Esquerdo: Verde com Ilustração -->
    <div class="col-md-6 d-none d-md-flex align-items-center justify-content-center left-side">
      <div class="illustration-container">
        <img src="assets/login-lawservices.jpeg" alt="Ilustração Login" class="img-fluid illustration" />
      </div>
    </div>

    <!-- Lado Direito: Formulário -->
    <div class="col-md-6 d-flex align-items-center justify-content-center right-side">
      <div class="login-card-wrapper">
        <app-formulario></app-formulario>
      </div>
    </div>
  </div>
</section>
